import { render } from "./PartnerApplicationsView.vue?vue&type=template&id=60ad3d16"
import script from "./PartnerApplicationsView.vue?vue&type=script&lang=js"
export * from "./PartnerApplicationsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__